import React from 'react';

export default function Hero() {
  return (
    <section
      className="relative flex flex-col items-center justify-center text-center py-12 min-h-screen overflow-hidden"
      data-aos="fade-up" data-aos-delay="100"
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover -z-10 opacity-25"
      >
        <source src="./website-bg.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <header className="my-10 max-w-5xl px-4 md:px-0 z-10">
        <h1
          className="text-white text-[2.5rem] md:text-[5rem] mb-6"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          An invisible graphics card strapped to your computer
        </h1>
        <p
          className="text-white text-2xl md:text-3xl"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          Refray is an ultra-low latency cloud GPU that plays like real hardware
        </p>
      </header>

      <div
        className="flex flex-col md:flex-row gap-4 w-full md:w-auto px-4 md:px-0 z-10"
        data-aos="fade-up"
        data-aos-delay="600"
      >
        <a href="https://tally.so/r/mJvlzo">        
          <button
            className="bg-primary text-white px-8 text-xl py-4 hover:!bg-opacity-75 transition"
          >
            Request beta access
          </button>
        </a>
      </div>
    </section>
  );
}